export default __webpack_public_path__ + "static/media/donation-mobile.a44ddd45.png";